import { call, put } from 'redux-saga/effects';
import axios from 'axios';

import * as actions from '../actions/index';
import { alertDialogSetSaga } from './alertDialog';

import { getSessionToken, getUserEmail } from '../../constants/session';

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const resource = process.env.REACT_APP_PAYMENTS_OFFERS;

export default function* getPaymentsOffersSaga(action) {
    try {
        yield put(actions.paymentsOffersStart());

        const { limit, offset, incrementViewCount } = action.data || {};
        const email = getUserEmail();
        const url = baseUrl + resource;

        const sessionToken = getSessionToken();

        const response = yield axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: sessionToken,
            },
            params: {
                username: email,
                limit,
                offset,
                // Only sent (as true) from the Working Capital page so the DB counts
                // it as a view; the dashboard banner fetch omits it.
                ...(incrementViewCount ? { incrementViewCount: true } : {}),
            },
        });

        // This endpoint returns the offers array directly under `result`
        // (i.e. { header, result: [...] }), unlike the other endpoints that
        // nest the payload under a named key such as `result.payments`.
        const data = {
            offers: response.data.result ? response.data.result : null,
        };

        yield put(actions.paymentsOffersSuccess(data));
    } catch (error) {
        yield call(alertDialogSetSaga, {
            data: {
                open: true,
                severityLevel: 'error',
                message: error?.response?.data?.error ?? error?.message,
            },
        });
        yield put(actions.paymentsOffersFail(error));
    }
}
